import type { RequestMiddleware } from "graphql-request"

export const addFeatureFlagHeaders =
  (anonymousId: string): RequestMiddleware =>
  request => ({
    ...request,
    headers: {
      ...request.headers,
      "x-bounce-feature-flag-user-id": anonymousId,
    },
  })
